import { Component, Prop, Vue } from 'vue-property-decorator';

import HeaderCol from '../header.col/header.col.vue';

// 操作按钮
@Component({ name: 'HeaderOperation', components: { HeaderCol } })
export default class extends Vue {
    @Prop({ required: true }) public searching!: boolean;
}
